import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const TableLoader = ({ 
  rows = 5, 
  columns = 4, 
  className = '',
  showHeader = true
}) => {
  return (
    <div className={`table-loader ${className}`}>
      <div className="table-wrapper flex flex-col shadow-xs rounded-xl">
        <div className="table">
          <table className="w-full">
            {showHeader && (
              <thead>
                <tr>
                  {[...Array(columns)].map((_, index) => (
                    <th key={index} className="header-data">
                      <div className="skeleton-header bg-gray-200 rounded h-4 w-24 animate-pulse"></div>
                    </th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {[...Array(rows)].map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {[...Array(columns)].map((_, colIndex) => (
                    <td key={colIndex} className="row-container">
                      <div className="skeleton-cell bg-gray-200 rounded h-4 w-full animate-pulse"></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

TableLoader.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
  className: PropTypes.string,
  showHeader: PropTypes.bool,
};

export default TableLoader;
